import { createBrowserHistory, createMemoryHistory } from 'history';
import { DigitalDataStrategy, AnalyticsMgr, BCManager, GBDManager, IVMgr, CoreFlagMgr } from '@nab/nab-x-sdk-browser';
import {
    AppServices,
    IAnalyticsMgr,
    ServicesConfig,
    ServicesProvider,
    IDataSecurityMgr,
    IAnalyticsStrategy,
    ICoreFlagMgr,
    IFlagStrategy,
    IDataSecurityConfig
} from '@nab/x-types';

interface AnalyticsInfo {
    strategy: IAnalyticsStrategy;
}
const createAnalyticsMgr: (analyticsInfo: AnalyticsInfo) => IAnalyticsMgr = ({ strategy = null }) =>
    new AnalyticsMgr(strategy || new DigitalDataStrategy());

const createDataSecurityMgr: (dataSecurityInfo: IDataSecurityConfig) => IDataSecurityMgr = ({
    iv: { LibraryUrl: ivLib, configValue: ivConfig } = { LibraryUrl: '' },
    gbd: { LibraryUrl: gbdLib, configValue: gbdConfig } = { LibraryUrl: '' },
    bc: { LibraryUrl: bcLib, configValue: bcConfig } = { LibraryUrl: '' }
}) => ({
    bc: new BCManager(bcLib, bcConfig),
    gbd: new GBDManager(gbdLib, gbdConfig),
    iv: new IVMgr(ivLib, ivConfig)
});

interface FlagMgrInfo {
    strategy: IFlagStrategy;
}
const createFlagMgr: (flagMgrInfo: FlagMgrInfo) => ICoreFlagMgr = ({ strategy = null }) => {
    const flagMgr = new CoreFlagMgr();
    return flagMgr;
};

export const defaultServicesProvider: ServicesProvider = (servicesConfig?: ServicesConfig): AppServices => {
    const analyticsMgr = createAnalyticsMgr((servicesConfig && servicesConfig.analytics) || ({} as AnalyticsInfo));
    const dataSecurityMgr = createDataSecurityMgr(
        (servicesConfig && servicesConfig.dataSecurity) ||
            ({ iv: { LibraryUrl: '' }, gbd: { LibraryUrl: '' }, bc: { LibraryUrl: '' } } as IDataSecurityConfig)
    );
    const flagMgr = createFlagMgr((servicesConfig && servicesConfig.flags) || ({} as FlagMgrInfo));
    const history = servicesConfig?.history?.suppressRouting
        ? createMemoryHistory()
        : createBrowserHistory({
              basename: servicesConfig?.history?.routingBasePath || ''
          });
    return {
        analyticsMgr,
        dataSecurityMgr,
        flagMgr,
        history
    };
};
